/* Uitgelicht product (homepage-ontwerp): pijlen op de hoofdfoto sturen de Swiper-slider van het theme,
   de pijlknop onder de thumbnails scrolt de thumbnailkolom */
(() => {
    const column = (el) => el.closest('.l4pr-container')?.querySelector('.swiper-custom-pagination');

    /* Knop verbergen als alles past, en omdraaien (omhoog) als de kolom onderaan is */
    const updateThumbsButton = (container) => {
        const button = container.querySelector('[data-ts-fp-thumbs]');
        const col = container.querySelector('.swiper-custom-pagination');
        if (!button || !col) return;
        const max = col.scrollHeight - col.clientHeight;
        button.hidden = max < 2;
        button.toggleAttribute('data-at-end', col.scrollTop >= max - 2);
    };

    /* Actieve thumbnail in beeld houden binnen de kolom */
    const revealActive = (container) => {
        const col = container.querySelector('.swiper-custom-pagination');
        const active = col && col.querySelector('.swiper-pagination-bullet-active');
        if (!active) return;
        const top = active.offsetTop - col.offsetTop;
        const bottom = top + active.offsetHeight;
        if (top < col.scrollTop) col.scrollTo({ top, behavior: 'smooth' });
        else if (bottom > col.scrollTop + col.clientHeight) col.scrollTo({ top: bottom - col.clientHeight, behavior: 'smooth' });
    };

    const init = (container) => {
        if (container.dataset.tsFpInit) return;
        const col = container.querySelector('.swiper-custom-pagination');
        if (!col) return;
        container.dataset.tsFpInit = 'true';
        col.addEventListener('scroll', () => updateThumbsButton(container), { passive: true });
        new ResizeObserver(() => updateThumbsButton(container)).observe(col);
        new MutationObserver(() => revealActive(container)).observe(col, { subtree: true, attributes: true, attributeFilter: ['class'] });
        updateThumbsButton(container);
    };

    /* De thumbnails worden door het theme (Swiper) opgebouwd, dus wachten tot ze er zijn */
    const containers = () => [...document.querySelectorAll('.ts-fp .l4pr-container')];
    const scan = () => {
        containers().forEach((c) => {
            if (c.querySelector('.swiper-custom-pagination .swiper-pagination-bullet')) init(c);
        });
        if (containers().every((c) => c.dataset.tsFpInit)) observer.disconnect();
    };
    const observer = new MutationObserver(scan);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    scan();

    document.addEventListener('click', (e) => {
        const nav = e.target.closest('[data-ts-fp-nav]');
        if (nav) {
            const swiper = nav.closest('.l4pr-container')?.querySelector('.l4pr .swiper-outer')?.swiper;
            if (!swiper) return;
            if (Number(nav.dataset.tsFpNav) < 0) swiper.slidePrev();
            else swiper.slideNext();
            return;
        }

        const more = e.target.closest('[data-ts-fp-thumbs]');
        if (more) {
            const col = column(more);
            if (!col) return;
            const bullet = col.querySelector('.swiper-pagination-bullet');
            const step = bullet ? bullet.offsetHeight + parseFloat(getComputedStyle(bullet).marginBottom || 0) : 200;
            const max = col.scrollHeight - col.clientHeight;
            col.scrollTo({ top: col.scrollTop >= max - 2 ? 0 : col.scrollTop + step, behavior: 'smooth' });
        }
    });
})();
